import styled from 'styled-components';

export const EllipsisMenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  z-index: ${(props) => (props.$isOpen ? 1000 : 10)};
`;

export const EllipsisButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 4px 4px;
  width: 32px;
  height: 32px;
  transition: background-color 0.15s ease-out;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const EllipsisDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  min-width: 160px;
  z-index: 1000;
  background: rgba(28, 28, 28, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
`;

export const EllipsisMenuContent = styled.div`
  padding: 4px;

  ul {
    background: transparent;
    border-radius: 8px;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      color: #ffffff;
      cursor: pointer;
      padding: 12px 16px;
      border-radius: 8px;
      list-style: none;
      transition: background-color 0.15s ease-out;

      &:hover {
        background: rgba(255, 255, 255, 0.12);
      }
    }
  }
`;
